module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("f7eKe"))).then(() => parcelRequire('f4eak'));